<script setup lang="ts">
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { format } from "date-fns";
import type { Reservation } from "../../Dashboard/components/event.vue";
import type { PaginatedData } from "@/types/Pagination";

const props = defineProps<{
    data: PaginatedData<Reservation>;
}>();

const emit = defineEmits(["prevPage", "nextPage"]);
</script>

<template>
    <div class="w-full">
        <div class="flex items-center gap-2 py-4"></div>
        <div class="rounded-md border">
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>
                            {{ $t("team_reports.table.email") }}
                        </TableHead>
                        <TableHead>
                            {{ $t("team_reports.table.name") }}</TableHead
                        >
                        <TableHead>
                            {{
                                $t("team_reports.table.reservation_start")
                            }}</TableHead
                        >
                        <TableHead>
                            {{ $t("team_reports.table.status") }}
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow v-for="row of data.data" :key="row.id">
                        <TableCell class="font-medium">
                            {{ row.email }}
                        </TableCell>
                        <TableCell>
                            {{ row.firstname + " " + row.lastname }}</TableCell
                        >
                        <TableCell>{{
                            format(new Date(row.start), "d. M. yyyy HH:mm ")
                        }}</TableCell>
                        <TableCell class="text-right">
                            {{ row.status }}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>

        <div class="flex items-center space-x-2 py-4">
            <div class="space-x-2">
                <Button
                    variant="outline"
                    size="sm"
                    :disabled="data.current_page === 1"
                    @click="emit('prevPage')"
                >
                    {{ $t("team_reports.table.prev") }}
                </Button>
                <Button
                    variant="outline"
                    size="sm"
                    :disabled="data.next_page_url === null"
                    @click="emit('nextPage')"
                >
                    {{ $t("team_reports.table.next") }}
                </Button>
            </div>
        </div>
    </div>
</template>
